import type { AudioCaptureOptions } from 'livekit-client';

import { VITE_DISABLE_BROWSER_NOISE_SUPPRESSION } from './environments';

export const getCallerAudioCapture = (disableNoiseSuppression: boolean): AudioCaptureOptions =>
  disableNoiseSuppression ? { noiseSuppression: false, voiceIsolation: false } : {};

export const CALLER_AUDIO_CAPTURE = getCallerAudioCapture(VITE_DISABLE_BROWSER_NOISE_SUPPRESSION);
